import React from "react";
import { Route, Switch } from "react-router-dom";
import { SessionList } from "./SessionList";
import SessionView from "./SessionView";

export default () => {
  return {
    routes: [
      {
        path: "/bosch-session-logs",
        render: ({ match }) => (
          <Switch>
            <Route path={`${match.url}`} exact component={SessionList} />
            <Route path={`${match.url}/:id`} exact>
              {(props) => <SessionView {...props} />}
            </Route>
          </Switch>
        ),
      },
    ],
  };
};
